module.exports = __webpack_public_path__ + "static/media/goBack.ec46a2ea.svg";